import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var PencilSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M20.28 8.135l.802-.803a3.147 3.147 0 000-4.442c-1.185-1.186-3.25-1.187-4.436 0l-.808.809 4.443 4.436zM18.859 9.557l-9.11 9.123c-.077.077-.163.14-.26.188l-6.042 3.027a.999.999 0 01-1.434-.736 1.003 1.003 0 01.093-.608l3.02-6.053c.049-.096.112-.182.188-.26l9.109-9.123 4.436 4.442z", fill: "currentColor" })] })));
};

export { PencilSolidIcon };
//# sourceMappingURL=PencilSolidIcon.js.map
